import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/openid': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M271.5 432L203.5 464C88.5 453.7 0 392.5 0 318.2 0 246.7 82.5 187.2 191.7 173.9V216.9C120.2 229.4 67.7 269.9 67.7 318.2 67.7 369.2 126.2 411.5 203.4 421.2V81.2L271.4 48V432zM448 291L316.7 262.5 353.5 241.8C334 230.3 310 221.8 283.5 217V174C329.7 179.5 371.2 193.5 403.8 213.3L438.8 193.5 448 291z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/openid.js
// module id = RTYL
// module chunks = 144